<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="white"
    />
    <path
      d="M26 19.6667C26.0023 20.5466 25.7967 21.4146 25.4 22.2C24.9296 23.1412 24.2065 23.9328 23.3116 24.4862C22.4168 25.0396 21.3855 25.3329 20.3333 25.3334C19.4534 25.3356 18.5854 25.1301 17.8 24.7334L14 26L15.2667 22.2C14.87 21.4146 14.6644 20.5466 14.6667 19.6667C14.6671 18.6145 14.9604 17.5833 15.5138 16.6884C16.0672 15.7935 16.8588 15.0704 17.8 14.6C18.5854 14.2033 19.4534 13.9977 20.3333 14H20.6667C22.0562 14.0767 23.3687 14.6632 24.3528 15.6473C25.3368 16.6313 25.9233 17.9438 26 19.3334V19.6667Z"
      stroke="#040325"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
